import React from 'react'
import Confirm from 'views/confirm/confirm'
import { connect } from 'react-redux'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import myLibraryActions from 'redux/actions/my_library_actions'
import { localize } from 'helpers/translator'

const MyLibraryAyceDowngrade = props => (
	<Confirm
		alertTitle={localize('ayce_downgrade_title')}
		btTwo={localize('ayce_downgrade_button')}
		alertMessage={localize('ayce_downgrade_message')}
		actionTwo={props.actions.closeAyceDowngradeAccount}
		closeAction={props.actions.closeAyceDowngradeAccount}
	/>
)

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeAyceDowngradeAccount: myLibraryActions.closeAyceDowngradeAccount,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(MyLibraryAyceDowngrade)

export { MyLibraryAyceDowngrade }
